var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefunded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3052_951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2C11.5823 2 13.129 2.46919 14.4446 3.34824C15.7602 4.22729 16.7855 5.47672 17.391 6.93853C17.9965 8.40034 18.155 10.0089 17.8463 11.5607C17.5376 13.1126 16.7757 14.538 15.6569 15.6569C14.538 16.7757 13.1126 17.5376 11.5607 17.8463C10.0089 18.155 8.40035 17.9965 6.93854 17.391C5.47673 16.7855 4.2273 15.7602 3.34825 14.4446C2.4692 13.129 2 11.5823 2 10C2 7.87827 2.84286 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0V0Z",
    fill: "#FC8575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.64 7.58141C9.08397 7.59057 7.58963 8.19116 6.46003 9.26141L4.28003 6.94141V12.7414H9.73003L7.53003 10.4014C8.38128 9.62717 9.48936 9.19605 10.64 9.19141C11.6847 9.21125 12.6955 9.56589 13.5236 10.2031C14.3516 10.8404 14.9533 11.7266 15.24 12.7314L16.68 12.2214C16.3003 10.9046 15.5092 9.74385 14.4224 8.90896C13.3356 8.07408 12.0102 7.60887 10.64 7.58141Z",
    fill: "#FC8575",
    stroke: "#FC8575",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3052_951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefunded);
export default __webpack_public_path__ + "static/media/Refunded.1439054a2e374258f4079c21f3c1a0cd.svg";
export { ForwardRef as ReactComponent };